import { render, staticRenderFns } from "./StatGraphComponent.vue?vue&type=template&id=58f7a856&scoped=true&"
import script from "./StatGraphComponent.vue?vue&type=script&lang=js&"
export * from "./StatGraphComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f7a856",
  null
  
)

export default component.exports